import permission from './directive/permission.js'

const directive = {
    install(Vue){
        Vue.directive('permission', permission)

    }
}

export default directive